import './patientInformationComponent.scss'
import React, {useCallback, useEffect, useState} from 'react';
import FormTitleWithNavigationBack
    from "../../../../shared/components/form-title-with-navigation-back/FormTitleWithNavigationBack";
import * as Yup from "yup";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import FormikAutoCompleteDropdown
    from "../../../../shared/components/core/formik-auto-complete-dropdown/formikAutoCompleteDropdown";
import CommonService from "../../../../shared/services/common.service";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import Grid from "@mui/material/Grid";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import FormikInputComponent from "../../../../shared/components/core/formik-input/FormikInputComponent";
import FormikDatePickerComponent from "../../../../shared/components/core/formik-date-picker/FormikDatePickerComponent";
import {ImageConfig} from "../../../../constants";
import {useNavigate} from "react-router-dom";
import FormikSelectDropdownComponent
    from "../../../../shared/components/core/formik-select-dropdown/FormikSelectDropdownComponent";
import DrawerComponent from "../../../../shared/components/drawer/drawerComponent";
import OtpComponent from "../../../../shared/components/otp/otpComponent";
import TimerComponent from "../../../../shared/components/timer/timerComponent";
import formValidationRules from "../../../../shared/services/validation.service";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import StatusCardComponent from "../../../../shared/components/status-card/statusCardComponent";
import HeadingComponent from "../../../../shared/components/heading/headingComponent";
import LottieFileGenarationComponent
    from "../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";

interface PatientInformationComponentProps {
    next: Function;
    cancel: Function;
}

const OTP_LENGTH = 6;
const OTP_WAIT_TIME = 90;

const PatientBasicInformationValidationSchema = Yup.object({
    facilityId: Yup.mixed().required("Facility name is required").nullable(),
    locationId: Yup.mixed().required("location name is required").nullable(),
    suffix: Yup.string(),
    prefix: Yup.string(),
    firstName: Yup.string()
        .required("First Name  is required")
        .max(100, 'First name maximum limit should be 100 characters')
        .nullable(),
    middleName: Yup.string()
        .max(100, 'Middle name maximum limit should be 100 characters')
        .nullable(),
    lastName: Yup.string()
        .required("Last Name  is required")
        .max(100, 'Last name maximum limit should be 100 characters')
        .nullable(),
    dateOfBirth: Yup.date().required("Date of birth  is required")
        .typeError("Please Enter valid Date")
        .min(new Date(1900, 0, 1), "Date of birth should be greater than 01/01/1900")
        .max(new Date(), "Can not be in the future")
        .nullable(),
    isPatientVerified: Yup.boolean(),
});
const PatientBasicInformationValidationSchemaAfterVerified = Yup.object({
    facilityId: Yup.mixed().required("Facility name is required").nullable(),
    locationId: Yup.mixed().required("location name is required").nullable(),
    suffix: Yup.string(),
    prefix: Yup.string(),
    firstName: Yup.string()
        .required("First Name  is required")
        .max(100, 'First name maximum limit should be 100 characters')
        .nullable(),
    middleName: Yup.string()
        .max(100, 'Middle name maximum limit should be 100 characters')
        .nullable(),
    lastName: Yup.string()
        .required("Last Name  is required")
        .max(100, 'Last name maximum limit should be 100 characters')
        .nullable(),
    dateOfBirth: Yup.date().required("Date of birth  is required")
        .typeError("Please Enter valid Date")
        .min(new Date(1900, 0, 1), "Date of birth should be greater than 01/01/1900")
        .max(new Date(), "Can not be in the future")
        .nullable(),
    isPatientVerified: Yup.boolean(),
    gender: Yup.string().required('Gender is Required').nullable(),
    race: Yup.string().required('Race is Required').nullable(),
    ethnicity: Yup.string().required('Ethnicity is Required').nullable(),
    weight: Yup.number()
        .min(0, 'Weight should be greater than 0')
        .max(1400, 'Max weight can be 1400 lbs').nullable(),
    heightInInches: Yup.string().nullable(),
    heightInFeet: Yup.string().nullable(),
});

interface patientBasicInformationFormSchema {
    facilityId: string;
    locationId: string;
    suffix: string,
    prefix: string,
    firstName: string,
    middleName: string,
    lastName: string,
    dateOfBirth: string,
    isPatientVerified: boolean,
}

interface patientAdditionalDetailsSchema {
    facilityId: string;
    locationId: string;
    suffix: string,
    prefix: string,
    firstName: string,
    middleName: string,
    lastName: string,
    dateOfBirth: string,
    isPatientVerified: boolean,
    gender: string;
    weight: string;
    race: string;
    ethnicity: string;
    heightInInches: string;
    heightInFeet: string;
}

const basicInformationFormInitialValues: patientBasicInformationFormSchema = {
    facilityId: "",
    locationId: "",
    suffix: "",
    prefix: "",
    firstName: "",
    middleName: "",
    lastName: "",
    dateOfBirth: "",
    isPatientVerified: false
}
const patientAdditionalDetailsInitialValues: patientAdditionalDetailsSchema = {
    facilityId: "",
    locationId: "",
    suffix: "",
    prefix: "",
    firstName: "",
    middleName: "",
    lastName: "",
    dateOfBirth: "",
    isPatientVerified: false,
    gender: "",
    weight: "",
    race: "",
    ethnicity: "",
    heightInInches: "",
    heightInFeet: "",
}


const PatientInformationComponent = (props: PatientInformationComponentProps) => {
        const {next, cancel} = props;
        const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
        const {currentUser} = useSelector((state: IRootReducerState) => state.account);
        const {prefixList, suffixList} = useSelector((state: IRootReducerState) => state.staticData);
        const {ethnicityList, raceList} = useSelector((state: IRootReducerState) => state.staticData);
        const loggedInUserFacilityDetails = currentUser?.facilityDetails
        const loggedInUserLocationDetails = currentUser?.locationDetails
        const navigate = useNavigate();
        const [PatientBasicInformationInitialValues, setPatientBasicInformationInitialValues] = useState<patientBasicInformationFormSchema>(basicInformationFormInitialValues);
        const [PatientAdditionalInformationInitialValues, setPatientAdditionalInformationInitialValues] = useState<patientAdditionalDetailsSchema>(patientAdditionalDetailsInitialValues);
        const [facilityList, setFacilityList] = useState<any>([]);
        const [isFacilityListLoading, setIsFacilityListLoading] = useState<boolean>(false);
        const [isFacilityListLoadingFailed, setIsFacilityListLoadingFailed] = useState<boolean>(false);
        const [locationList, setLocationList] = useState<any>([]);
        const [isLocationListLoading, setIsLocationListLoading] = useState<boolean>(false);
        const [isLocationListLoadingFailed, setIsLocationListLoadingFailed] = useState<boolean>(false);
        const [isPatientBelongsToFacility, setPatientBelongsToFacility] = useState<boolean | undefined>(undefined);
        const [isPatientAlreadyExists, setPatientAlreadyExists] = useState<boolean | undefined>(undefined);
        const [buttonContent, setButtonContent] = useState<string>('Proceed');
        const [showOTPDrawer, setShowOTPDrawer] = useState<boolean>(false);
        const [patientDetails, setPatientDetails] = useState<any>(undefined);
        const [noOfSecondsLeftToRequestForNewOTP, setNoOfSecondsLeftToRequestForNewOTP] = useState(0);
        const [isOTPLoaded, setIsOTPLoaded] = useState<boolean>(false);
        const [isOTPLoading, setIsOTPLoading] = useState<boolean>(false);
        const [isOTPLoadingFailed, setIsOTPLoadingFailed] = useState<boolean>(false);
        const [otp, setOtp] = useState<string>();
        const [isOtpSubmitting, setIsOtpSubmitting] = useState<any>(false);
        const [intervalSub, setIntervalSub] = useState<any>(null);
        const [facilityDetails, setFacilityDetails] = useState<any>(null);
        const [locationDetails, setLocationDetails] = useState<any>(null);

        const getFacilityList = useCallback(() => {
            const payload = {isActive: true};
            setIsFacilityListLoading(true);
            setIsFacilityListLoadingFailed(false);
            let facilityList: any = [];
            CommonService._facility.getFacilityListLite(payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response?.data) {
                        facilityList = response.data;
                    }
                    setFacilityList(facilityList);
                    setIsFacilityListLoading(false);
                    setIsFacilityListLoadingFailed(false);
                })
                .catch((error: any) => {
                    setIsFacilityListLoading(false);
                    setIsFacilityListLoadingFailed(true);
                });
        }, []);

        const runTimer = useCallback(() => {
            let setIntervalVal: any = null;
            if (intervalSub) {
                clearInterval(intervalSub);
            }
            setNoOfSecondsLeftToRequestForNewOTP(OTP_WAIT_TIME);
            setIntervalVal = setInterval(() => {
                setNoOfSecondsLeftToRequestForNewOTP((oldState: any) => {
                    if (oldState > 0) {
                        return oldState - 1;
                    } else {
                        clearInterval(setIntervalVal);
                        return 0;
                    }
                });
            }, 1000);
            setIntervalSub(setIntervalVal);
        }, [intervalSub]);

        const sendOTPEmail = useCallback(() => {
            setIsOTPLoaded(false);
            setIsOTPLoading(true);
            setIsOTPLoadingFailed(false);
            const payload = {};
            CommonService._patient.sendOTPtoPatient(patientDetails?.id, payload)
                .then((response: IAPIResponseType<any>) => {
                    runTimer();
                    setIsOTPLoaded(true);
                    setIsOTPLoading(false);
                    setIsOTPLoadingFailed(false);
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error?.error || "Failed to send OTP", "error");
                    setIsOTPLoaded(false);
                    setIsOTPLoading(false);
                    setIsOTPLoadingFailed(true);
                });
        }, [patientDetails, runTimer]);

        const handleEmailResend = useCallback(() => {
            if (noOfSecondsLeftToRequestForNewOTP > 0) {
                CommonService._alert.showToast(`Please request for new OTP after ${noOfSecondsLeftToRequestForNewOTP} seconds`, "info");
                return;
            }
            setOtp('');
            sendOTPEmail();
        }, [noOfSecondsLeftToRequestForNewOTP, sendOTPEmail]);

        const closeOtpDrawer = useCallback(() => {
            setOtp('');
            setShowOTPDrawer(false);
            if (intervalSub) {
                clearInterval(intervalSub);
            }
        }, [intervalSub]);

        const handleOtpDrawer = useCallback(() => {
            setShowOTPDrawer(true);
            sendOTPEmail();
        }, [sendOTPEmail])

        const handlePatientOTPRequestPopup = useCallback((values: any, {
            setSubmitting,
        }: FormikHelpers<any>) => {
            setSubmitting(false);
            CommonService.openConfirmationDialog({
                confirmationTitle: 'Please confirm!',
                confirmationSubTitle: 'Are you sure you want to continue adding this patient?',
                disableEscKeyClose: false,
                disableBackdropClose: true,
                imagePath: `${ImageConfig.ConfirmationImage}`,
                direction: "up",
                yes: {
                    text: "Continue",
                    color: "primary"
                },
                no: {
                    text: "Cancel",
                    color: "primary"
                }

            }).then(() => {
                handleOtpDrawer();
            })
                .catch(() => {
                });
        }, [handleOtpDrawer]);

        const handleADDSuccess = useCallback(() => {
            CommonService.openConfirmationDialog({
                confirmationTitle: 'Congratulations! ',
                confirmationSubTitle: 'Patient has been added successfully.',
                disableEscKeyClose: false,
                disableBackdropClose: true,
                imagePath: `${ImageConfig.CongratulationImage}`,
                direction: "up",
                hideNoOption: true,
                yes: {
                    text: "Proceed",
                    color: "primary"
                }

            }).then(() => {
                navigate(CommonService._routeConfig.PatientListRoute());
            })
                .catch(() => {
                });
        }, [navigate]);


        const onVerifyOtp = useCallback(() => {
            setIsOtpSubmitting(true);
            const payload = {
                'otp': otp,
                facilityId: facilityDetails?.id,
                locationId: locationDetails?.id
            }
            CommonService._patient.verifyPhoneNumberOtp(patientDetails?.id, payload)
                .then((response: IAPIResponseType<any>) => {
                    setIsOtpSubmitting(false);
                    setShowOTPDrawer(false);
                    CommonService._alert.showToast(response.message || "OTP verification completed successfully", "success");
                    handleADDSuccess();
                })
                .catch((error: any) => {
                    CommonService._alert.showToast('Wrong OTP', "error");
                    setIsOtpSubmitting(false);
                })
        }, [otp, facilityDetails?.id, locationDetails?.id, patientDetails?.id, handleADDSuccess]);

        const getLocationList = useCallback((facilityID: any) => {
            const payload = {facilityId: facilityID, isActive: true};
            setIsLocationListLoading(true);
            setIsLocationListLoadingFailed(false);
            let locationList: any = [];
            CommonService._location.getLocationListLite(payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response?.data) {
                        locationList = response.data;
                    }
                    setLocationList(locationList);
                    setIsLocationListLoading(false);
                    setIsLocationListLoadingFailed(false);
                })
                .catch((error: any) => {
                    setIsLocationListLoading(false);
                    setIsLocationListLoadingFailed(true);
                });
        }, []);

        // const handlePatientAlreadyExists = useCallback(() => {
        //     CommonService.openConfirmationDialog({
        //         confirmationTitle: 'Please confirm!',
        //         confirmationSubTitle: 'Are you sure you want to continue adding this patient?',
        //         confirmationDescription: 'patient already existed in date base please go to list and check',
        //         disableEscKeyClose: false,
        //         disableBackdropClose: true,
        //         imagePath: `${ImageConfig.AddingFlow}`,
        //         direction: "up",
        //         yes: {
        //             text: "Yes",
        //             color: "primary"
        //         },
        //         no: {
        //             text: "No",
        //             color: "primary"
        //         }
        //     })
        //         .then(() => {
        //             navigate(CommonService._routeConfig.PatientListRoute());
        //         })
        //         .catch(() => {
        //         })
        // }, [navigate]);


        useEffect(() => {
            if (isPatientBelongsToFacility && isPatientAlreadyExists) {
                // handlePatientAlreadyExists();
            } else if (!isPatientBelongsToFacility && isPatientAlreadyExists) {
                setButtonContent('Request OTP');
            } else if (!isPatientBelongsToFacility && isPatientAlreadyExists !== false) {

            }
        }, [isPatientBelongsToFacility, isPatientAlreadyExists]);

        //this block is required when user has been redirect from test order creation
        useEffect(() => {
            if (queryParamData?.facilityId && queryParamData?.locationId) {
                setPatientBasicInformationInitialValues((prev) => {
                    return {
                        ...prev,
                        facilityId: facilityList.find((item: any) => item.id === +(queryParamData?.facilityId)),
                        locationId: locationList.find((item: any) => item.id === +(queryParamData?.locationId)),
                    }
                })
            }
        }, [queryParamData, facilityList, locationList, getLocationList]);
        //setting up the location id based upon facility id
        useEffect(() => {
            if (queryParamData?.facilityId) {
                getLocationList(queryParamData?.facilityId)
            }
        }, [getLocationList, queryParamData?.facilityId]);


        const onPatientVerify = useCallback((values: any, {
            setSubmitting,
            setErrors,
            setFieldValue
        }: FormikHelpers<any>) => {
            if (values?.isPatientVerified) {
                const payload = {...values}
                payload.facilityId = payload.facilityId?.id;
                payload.locationId = payload.locationId?.id;
                payload.weight = Number(payload.weight);
                payload.dateOfBirth = CommonService.convertDateFormat(payload['dateOfBirth'], 'YYYY-MM-DD');
                delete payload['facilityDetails'];
                delete payload['locationDetails'];
                setSubmitting(true);
                CommonService._patient.addPatientInformation(payload)
                    .then((response: IAPIResponseType<any>) => {
                        setSubmitting(false);
                        next(response.data.id);
                    })
                    .catch((error: any) => {
                        CommonService.handleErrors(setErrors, error);
                        setSubmitting(false);
                    });
            } else {
                setPatientAlreadyExists(undefined);
                setPatientBelongsToFacility(undefined);
                const payload = {
                    facilityId: values.facilityId.id,
                    locationId: values.locationId.id,
                    suffix: values.suffix,
                    prefix: values.prefix,
                    firstName: values.firstName,
                    lastName: values.lastName,
                    middleName: values.middleName,
                    dateOfBirth: CommonService.convertDateFormat(values['dateOfBirth'], 'YYYY-MM-DD'),
                };
                // delete payload['isPatientVerified'];
                setSubmitting(true);
                CommonService._patient.verifyPatientExistence(payload)
                    .then((response: IAPIResponseType<any>) => {
                        setSubmitting(false);
                        setPatientAdditionalInformationInitialValues((prevState: any) => {
                            return {
                                ...prevState,
                                ...values,
                                isPatientVerified: true
                            }
                        });
                        setPatientBelongsToFacility(response.data.isPatientBelongsToFacility);
                        setPatientAlreadyExists(response.data.isPatientExists);
                        setPatientDetails(response.data.patientDetails);
                    })
                    .catch((error: any) => {
                        CommonService.handleErrors(setErrors, error);
                        setSubmitting(false);
                    });
            }
        }, [next]);

        useEffect(() => {
            if (loggedInUserFacilityDetails) {
                const patientDetails: any = {}
                patientDetails.facilityId = loggedInUserFacilityDetails;
                setPatientBasicInformationInitialValues(
                    patientDetails
                );

            } else {
                getFacilityList();
            }
            //this block is required when user has been redirect from test order creation
            if (queryParamData?.facilityId && queryParamData?.locationId) {
                getFacilityList();
            }
        }, [getFacilityList, loggedInUserFacilityDetails, queryParamData?.facilityId, queryParamData?.locationId]);

        useEffect(() => {
            if (loggedInUserLocationDetails) {
                const patientDetails: any = {}
                patientDetails.locationId = loggedInUserLocationDetails;
                patientDetails.facilityId = loggedInUserFacilityDetails;
                setPatientBasicInformationInitialValues(
                    patientDetails
                )
            } else {
                if (loggedInUserFacilityDetails) {
                    getLocationList(loggedInUserFacilityDetails?.id);
                }
            }
        }, [getLocationList, loggedInUserFacilityDetails, loggedInUserLocationDetails]);

        const onFacilitySelection = useCallback((value: any) => {
            if (value?.id) {
                getLocationList(value.id);
                setFacilityDetails(value);
            } else {
                setFacilityDetails(undefined);
            }
        }, [getLocationList]);

        const onLocationSelection = useCallback((value: any) => {
            if (value?.id) {
                setLocationDetails(value);
            } else {
                setLocationDetails(undefined);
            }
        }, [setLocationDetails]);

        return (
            <div className="patient-information-screen screen t-form-screen">
                <FormTitleWithNavigationBack
                    title={'Patient Information'}
                    tooltipData={"If the patient already exists in AdvanzInnovation database, obtaining an OTP from them will onboard them. Ensure that the inputs provided are accurate."}
                />
                <div className="t-form">
                    <Formik
                        validationSchema={isPatientAlreadyExists === false ? PatientBasicInformationValidationSchemaAfterVerified : PatientBasicInformationValidationSchema}
                        initialValues={isPatientAlreadyExists === false ? PatientAdditionalInformationInitialValues : PatientBasicInformationInitialValues}
                        validateOnChange={true}
                        validateOnBlur={true}
                        enableReinitialize={true}
                        validateOnMount={true}
                        onSubmit={(buttonContent === 'Proceed' || !isPatientAlreadyExists) ? onPatientVerify : handlePatientOTPRequestPopup}
                    >
                        {({isSubmitting, errors, values, isValid, setFieldValue, validateForm}) => {
                            // eslint-disable-next-line react-hooks/rules-of-hooks
                            useEffect(() => {
                                validateForm();
                            }, [validateForm, values, errors]);
                            return (
                                <Form noValidate={true} className={"patient-basic-details-add-holder"}>
                                    <div className="t-form-controls-wrapper">
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                                <Field name={'facilityId'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikAutoCompleteDropdown
                                                                fullWidth={true}
                                                                label={"Facility Name"}
                                                                required={true}
                                                                multiple={false}
                                                                data={facilityList}
                                                                valueKey={"id"}
                                                                disabled={loggedInUserFacilityDetails || (queryParamData?.facilityId && queryParamData?.locationId)}
                                                                readOnly={isPatientAlreadyExists === false || isPatientBelongsToFacility === false}
                                                                isDataLoading={!loggedInUserFacilityDetails && isFacilityListLoading}
                                                                isDataLoadingFailed={!loggedInUserFacilityDetails && isFacilityListLoadingFailed}
                                                                placeholder={"Select Facility Name"}
                                                                formikField={field}
                                                                getOptionLabel={(option => (option.name) || '')}
                                                                onUpdate={(value: any) => {
                                                                    if (value) {
                                                                        setFieldValue('locationId', '');
                                                                        onFacilitySelection(value);
                                                                    } else {
                                                                        setFieldValue('locationId', '');
                                                                        setLocationList([]);
                                                                    }
                                                                }
                                                                }
                                                            />)}
                                                </Field>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} xl={6}>

                                                <Field name={'locationId'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikAutoCompleteDropdown
                                                                fullWidth={true}
                                                                label={"Location Name"}
                                                                required={true}
                                                                multiple={false}
                                                                data={locationList}
                                                                disabled={loggedInUserLocationDetails || (queryParamData?.facilityId && queryParamData?.locationId)}
                                                                readOnly={isPatientAlreadyExists === false || isPatientBelongsToFacility === false}
                                                                valueKey={"id"}
                                                                isDataLoading={!loggedInUserLocationDetails && isLocationListLoading}
                                                                isDataLoadingFailed={!loggedInUserLocationDetails && isLocationListLoadingFailed}
                                                                placeholder={"Select Location Name"}
                                                                formikField={field}
                                                                getOptionLabel={(option => (option.name) || '')}
                                                                onUpdate={(value) => {
                                                                    onLocationSelection(value);
                                                                }}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </Grid>
                                        </Grid>

                                        <div className="horizontal-line"/>

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                                <Field name={'prefix'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikSelectDropdownComponent
                                                                label={'Prefix'}
                                                                readOnly={isPatientAlreadyExists === false || isPatientBelongsToFacility === false}
                                                                placeholder={'Enter Prefix'}
                                                                options={prefixList}
                                                                valueKey={"code"}
                                                                getOptionLabel={(option) => (option.title)}
                                                                formikField={field}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                                <Field name={'suffix'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikSelectDropdownComponent
                                                                label={'Suffix'}
                                                                readOnly={isPatientAlreadyExists === false || isPatientBelongsToFacility === false}
                                                                placeholder={'Enter Suffix'}
                                                                options={suffixList}
                                                                valueKey={"code"}
                                                                getOptionLabel={(option) => (option.title)}
                                                                required={false}
                                                                formikField={field}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                                <Field name={'firstName'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikInputComponent
                                                                label={'First Name'}
                                                                readOnly={isPatientAlreadyExists === false || isPatientBelongsToFacility === false}
                                                                placeholder={'Enter First Name'}
                                                                type={"text"}
                                                                required={true}
                                                                formikField={field}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                                <Field name={'middleName'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikInputComponent
                                                                label={'Middle Name'}
                                                                readOnly={isPatientAlreadyExists === false || isPatientBelongsToFacility === false}
                                                                placeholder={'Enter Middle Name'}
                                                                type={"text"}
                                                                required={false}
                                                                formikField={field}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                                <Field name={'lastName'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikInputComponent
                                                                label={'Last Name'}
                                                                placeholder={'Enter Last Name'}
                                                                type={"text"}
                                                                readOnly={isPatientAlreadyExists === false || isPatientBelongsToFacility === false}
                                                                required={true}
                                                                formikField={field}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                                <Field name={'dateOfBirth'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikDatePickerComponent
                                                                label={'Date of Birth'}
                                                                formikField={field}
                                                                required={true}
                                                                maxDate={formValidationRules.today}
                                                                readOnly={isPatientAlreadyExists === false || isPatientBelongsToFacility === false}
                                                                placeholder={'Enter Date of Birth'}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </Grid>
                                        </Grid>

                                        {!isPatientBelongsToFacility && isPatientAlreadyExists &&
                                            <div className="patient-confirmation-test">
                                                The patient you want to add already exists. Request an OTP in order to add
                                                this
                                                patient.
                                            </div>}

                                        {isPatientBelongsToFacility && isPatientAlreadyExists &&
                                            <div className="patient-confirmation-test">
                                                The patient you want to add exists already. You may proceed with the Test
                                                Order
                                                for this patient.
                                            </div>}
                                        {
                                            isPatientAlreadyExists === false &&
                                            <div>
                                                <div className="horizontal-line"/>
                                                <div className="form-sub-title">Personal Details</div>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={12} md={6} xl={6}>
                                                        <Field name={'gender'}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikSelectDropdownComponent
                                                                        label={'Gender'}
                                                                        options={CommonService._staticData.genderOptions}
                                                                        placeholder={'Select Gender'}
                                                                        valueKey={'code'}
                                                                        required={true}
                                                                        getOptionLabel={(option) => (option.title)}
                                                                        formikField={field}/>
                                                                )
                                                            }
                                                        </Field>
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={6} xl={6}>
                                                        <Field name={'race'}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikSelectDropdownComponent
                                                                        label={'Race'}
                                                                        options={raceList}
                                                                        placeholder={'Select Race'}
                                                                        formikField={field}
                                                                        getOptionLabel={(option) => (option.title)}
                                                                        valueKey={"code"}
                                                                        required={true}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={12} md={6} xl={6}>
                                                        <Field name={'ethnicity'}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikSelectDropdownComponent
                                                                        label={'Ethnicity'}
                                                                        options={ethnicityList}
                                                                        placeholder={'Select '}
                                                                        formikField={field}
                                                                        getOptionLabel={(option) => (option.title)}
                                                                        valueKey={"code"}
                                                                        required={true}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={6} xl={6}>
                                                        <Field name={'weight'}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikInputComponent
                                                                        label={'Weight (in lbs)'}
                                                                        placeholder={'Enter Weight'}
                                                                        type={"number"}
                                                                        required={false}
                                                                        formikField={field}
                                                                        maxLength={4}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={12} md={6} xl={6}>
                                                        <Field name={'heightInFeet'}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikSelectDropdownComponent
                                                                        label={'Height (in feet)'}
                                                                        required={false}
                                                                        options={CommonService._staticData.heightInFeet}
                                                                        placeholder={'Select Height in feet'}
                                                                        formikField={field}
                                                                        valueKey={'code'}
                                                                        getOptionLabel={(option) => (option.title)}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={6} xl={6}>
                                                        <Field name={'heightInInches'}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikSelectDropdownComponent
                                                                        label={'Height (in inches)'}
                                                                        required={false}
                                                                        options={CommonService._staticData.heightInInches}
                                                                        placeholder={'Select Height in inches'}
                                                                        formikField={field}
                                                                        valueKey={'code'}
                                                                        getOptionLabel={(option) => (option.title)}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                    </Grid>
                                                </Grid>

                                            </div>
                                        }
                                    </div>
                                    {isPatientAlreadyExists !== false &&
                                        <div className="form-action-section">
                                            <ButtonComponent
                                                type="button"
                                                color={"primary"}
                                                variant={"outlined"}
                                                fullWidth={true}
                                                disabled={isSubmitting}
                                                handleClick={cancel}
                                            >
                                                Cancel
                                            </ButtonComponent>
                                            <ButtonComponent
                                                type="submit"
                                                color={"primary"}
                                                variant={"contained"}
                                                fullWidth={true}
                                                disabled={!isValid}
                                                isLoading={isSubmitting}
                                            >
                                                {buttonContent}
                                            </ButtonComponent>
                                        </div>
                                    }
                                    {isPatientAlreadyExists === false &&
                                        <div className="form-action-section">
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={12} md={6} xl={6}>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={6} xl={6}>
                                                    <ButtonComponent
                                                        type="submit"
                                                        color={"primary"}
                                                        variant={"contained"}
                                                        fullWidth={true}
                                                        disabled={!isValid}
                                                        isLoading={isSubmitting}
                                                    >
                                                        Next
                                                    </ButtonComponent>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    }

                                </Form>
                            )
                        }
                        }
                    </Formik>
                </div>

                <DrawerComponent
                    onClose={closeOtpDrawer}
                    closeOnBackDropClick={true}
                    closeOnEsc={true}
                    className={"drawer-wrapper"}
                    open={showOTPDrawer}
                >
                    <div className="otp-verification-form otp-drawer-container screen t-form-screen">
                        <div className="drawer-sub-header horizontal-vertical-center-align">
                            <HeadingComponent title={"OTP Verification"}/>
                        </div>
                        <div className={'t-form t-form-drawer'}>
                            <div className="no-form">
                                <div className="t-form-controls-wrapper">
                                    <div className="otp-drawer-description">Please enter the OTP we sent
                                        on&nbsp; <b>{CommonService.getMaskedMobileNumber(patientDetails?.mobileNumber)}</b>
                                    </div>
                                    {
                                        isOTPLoading && <div className="spinner-loading-wrapper">
                                            <LottieFileGenarationComponent
                                                loop={true}
                                                autoplay={true}
                                                animationData={ImageConfig.LoadingLottieFile}/>
                                            <div className="mrg-top-10">OTP is generating please wait</div>
                                        </div>
                                    }
                                    {
                                        isOTPLoadingFailed && <>
                                            <StatusCardComponent title={"Failed to send OTP"}/>
                                        </>
                                    }
                                    {isOTPLoaded && <>
                                        <OtpComponent
                                            isInputNum={true}
                                            numInputs={OTP_LENGTH}
                                            onUpdate={(otp: any) => {
                                                setOtp(otp);
                                            }}
                                        />
                                        <div className="d-flex justify-content-end mrg-top-20 pdd-right-20">
                                            {noOfSecondsLeftToRequestForNewOTP ?
                                                <>
                                                    <span className="mrg-right-5">Resend OTP in</span>
                                                    <TimerComponent
                                                        noOfSeconds={noOfSecondsLeftToRequestForNewOTP}/>
                                                </> : <>&nbsp;</>
                                            }
                                            {!noOfSecondsLeftToRequestForNewOTP &&
                                                <span
                                                    className={"email-resend-link " + (noOfSecondsLeftToRequestForNewOTP ? 'disabled' : '')}
                                                    id="email_resend_link"
                                                    onClick={() => handleEmailResend()}>Resend OTP</span>
                                            }
                                        </div>
                                    </>
                                    }
                                </div>
                                {isOTPLoaded &&
                                    <div className="drawer-actions form-action-section">
                                        <ButtonComponent
                                            type={"button"}
                                            color={'primary'}
                                            fullWidth={true}
                                            disabled={!otp}
                                            variant={"contained"}
                                            isLoading={isOtpSubmitting}
                                            handleClick={onVerifyOtp}
                                        >
                                            Verify
                                        </ButtonComponent>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </DrawerComponent>
            </div>
        )
    }

;

export default PatientInformationComponent;
